import { useContext, useState } from 'react';
import Brightness2Icon from '@material-ui/icons/Brightness2';
import WbSunnyRoundedIcon from '@material-ui/icons/WbSunnyRounded';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { ThemeContext } from '../../contexts/theme';
import { allProjects, skills, contact } from '../../portfolio';
import './Navbar.css';

const Navbar = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext);
  const [showNavList, setShowNavList] = useState(false);

  const toggleNavList = () => setShowNavList(!showNavList);

  return (
    <nav className='center nav'>
      <ul
        style={{ display: showNavList ? 'flex' : null }}
        className='nav__list'
      >
        {allProjects.length ? (
          <li className='nav__list-item'>
            <a
              href='#role-selector'
              onClick={(e) => {
                e.preventDefault();
                toggleNavList();

                // If we're on a role page, navigate back to home first
                if (window.location.hash.startsWith('#role-')) {
                  window.location.hash = '';
                  // Wait for navigation, then scroll
                  setTimeout(() => {
                    document.getElementById('role-selector')?.scrollIntoView({ behavior: 'smooth' });
                  }, 100);
                } else {
                  // Already on home page, just scroll
                  document.getElementById('role-selector')?.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className='link link--nav'
            >
              Projects
            </a>
          </li>
        ) : null}

        {skills.length ? (
          <li className='nav__list-item'>
            <a
              href='#skills'
              onClick={toggleNavList}
              className='link link--nav'
            >
              Skills
            </a>
          </li>
        ) : null}

        <li className='nav__list-item nav__list-item--news'>
          <a
            href='#news'
            onClick={toggleNavList}
            className='link link--nav'
          >
            News
          </a>
        </li>

        <li className='nav__list-item'>
          <a
            href='#blogpost'
            onClick={toggleNavList}
            className='link link--nav'
          >
            Blogpost
          </a>
        </li>

        {contact.email ? (
          <li className='nav__list-item'>
            <a
              href='#contact'
              onClick={toggleNavList}
              className='link link--nav'
            >
              Contact
            </a>
          </li>
        ) : null}
      </ul>

      <button
        type='button'
        onClick={toggleTheme}
        className='btn btn--icon nav__theme'
        aria-label='toggle theme'
      >
        {themeName === 'dark' ? <WbSunnyRoundedIcon /> : <Brightness2Icon />}
      </button>

      <button
        type='button'
        onClick={toggleNavList}
        className='btn btn--icon nav__hamburger'
        aria-label='toggle navigation'
      >
        {showNavList ? <CloseIcon /> : <MenuIcon />}
      </button>
    </nav>
  );
}

export default Navbar;
